import { IconWrapper } from '../IconWrapper';
import React from 'react';
import { useTheme } from 'styled-components';

export interface Props {
  /**
   * Size of the failure icon. default 48px
   */
  size?: number;

  /**
   * Color choice. default R400
   */
  color?: string;
}

/**
 * Exclamation icon.
 */
export const ExclamationIcon: React.FC<Props> = ({
  size = 48,
  color,
}: Props) => {
  const theme = useTheme();
  const resolvedColor =
    color ?? theme.atlas.semantic.color.status.error.default;
  return (
    <IconWrapper>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        id="exclamation-icon"
        width={size}
        height={size}
        viewBox="0 0 122.88 122.88"
      >
        <g>
          <path
            fill={resolvedColor}
            fillRule="evenodd"
            clipRule="evenodd"
            // eslint-disable-next-line max-len
            d="M61.44,0c33.926,0,61.44,27.514,61.44,61.44c0,33.926-27.514,61.439-61.44,61.439 C27.513,122.88,0,95.366,0,61.44C0,27.514,27.513,0,61.44,0L61.44,0z M52.687,90.555H69.44v14.81H52.687V90.555L52.687,90.555z M69.431,82.96H52.691c-1.665-20.343-5.159-29.414-5.159-49.729c0-7.492,6.075-13.57,13.567-13.57s13.57,6.078,13.57,13.57 C74.67,53.535,71.13,62.633,69.431,82.96L69.431,82.96z"
          />
        </g>
      </svg>
    </IconWrapper>
  );
};
